import React from "react";
import { useMantineTheme, Group, Text, Menu } from '@mantine/core';
import { IconArrowNarrowDown, IconArrowNarrowUp } from '@tabler/icons-react';
import { regexNoStriped } from "../../utils/globalFunctions";

const SortMenu = ({ stateSortList, stateSortSelected, fnSort, stateComponentTarget }) => {

    const theme = useMantineTheme();

    return (
        <Menu shadow="md">
            <Menu.Target>
                {stateComponentTarget}
            </Menu.Target>

            {typeof stateSortList === 'object' && Object.keys(stateSortList).length > 0 &&
                <Menu.Dropdown>
                    {Object.keys(stateSortList).map(key => {

                        const selectedInUse = regexNoStriped(stateSortList[key].slug) === regexNoStriped(stateSortSelected.slug);

                        return (
                            <Menu.Item
                                key={key}
                                onClick={() => {
                                    fnSort(stateSortList[key]);
                                }}

                                sx={{
                                    backgroundColor: selectedInUse ? (theme.colorScheme === 'light' ? theme.colors.blue[0] : theme.colors.dark[7]) : 'transparent'
                                }}
                            >
                                <Group spacing='xs'>
                                    {selectedInUse && (stateSortSelected.slug)[0] === '-' &&
                                        <IconArrowNarrowUp
                                            size={14}
                                            color={theme.colorScheme === 'light' ? 'black' : 'white'}
                                            style={{ marginLeft: 0 }}
                                            stroke={1.5}
                                        />
                                    }

                                    {selectedInUse && (stateSortSelected.slug)[0] !== '-' &&
                                        <IconArrowNarrowDown
                                            size={14}
                                            color={theme.colorScheme === 'light' ? 'black' : 'white'}
                                            style={{ marginLeft: 0 }}
                                            stroke={1.5}
                                        />
                                    }

                                    {!selectedInUse &&
                                        <IconArrowNarrowUp
                                            size={14}
                                            color='transparent'
                                            style={{ marginLeft: 0 }}
                                            stroke={1.5}
                                        />
                                    }

                                    <Text>
                                        {stateSortList[key].caption}
                                    </Text>
                                </Group>
                            </Menu.Item>
                        )
                    })}
                </Menu.Dropdown>
            }
        </Menu>
    )
}

export default SortMenu;